import { BLOG_ROUTING_BASE, WORDPRESS_ASSETS_ROOT } from 'config';

export function decodeHtmlEntities(text) {
  if (typeof text !== 'string') {
    throw new Error(`Failed to decode HTML entity: invalid type ${typeof text}`);
  }

  let decoded = text;

  const entities = {
    '&amp;': '\u0026',
    '&quot;': '\u0022',
    '&#039;': '\u0027',
  };

  return decoded.replace(/&amp;|&quot;|&#039;/g, (char) => entities[char]);
}

/**
 * removeLastTrailingSlash
 */

export function removeLastTrailingSlash(url) {
  if (typeof url !== 'string') return url;
  return url.replace(/\/$/, '');
}

export function removeExtraSpaces(text) {
  if (typeof text !== 'string') return;
  return text.replace(/\s+/g, ' ').trim();
}

export const addCanalPlusGTMClass = (string) => {
  let className = '';
  if (string == null) return className;

  if (string.includes('canalplus.com')) {
    className += ' canalpluscom';
  }

  if (string.includes('kup.pl.canalplus.com')) {
    className += ' kupcanalpluscom';
  }
  return className;
};

export function prepareBreadcrumbs(urlParams, basePath = '/artykuly') {
  if (!urlParams || urlParams == null) {
    return null;
  }

  const breadcrumbs = [{ route: BLOG_ROUTING_BASE, label: 'Blog', title: 'Blog', href: '/' }];

  // 1. Handle App Router Catch-All Routes (e.g., [...slug] gives an Array)
  if (Array.isArray(urlParams.slug)) {
    let currentHref = basePath;

    urlParams.slug.forEach((segment) => {
      currentHref += `/${segment}`;

      breadcrumbs.push({
        href: currentHref,
        route: segment,
        label: segment,
        // Optional: You could add logic here to capitalize the first letter
        title: segment.replace(/-/g, ' '),
      });
    });
  }
  // 2. Handle standard App Router dynamic routes (e.g., [slug] gives a String)
  else if (typeof urlParams.slug === 'string') {
    const currentHref = `/${urlParams.slug}`;

    breadcrumbs.push({
      href: currentHref,
      route: urlParams.slug,
      label: urlParams.slug,
      title: urlParams.slug.replace(/-/g, ' '),
    });
  }

  return breadcrumbs;
}

export const prepareImagePath = (uri) => {
  if (!uri) return null;
  if (uri.startsWith('/blog/cms-assets/')) return uri;

  const filename = uri.toString().split('/').pop();
  return `/blog/cms-assets/${filename}`;
};

// export const prepareImagePath = (uri) => {
//   if (uri == null) return null;
//   const uriArray = uri.toString().split('/');
//   const lastElement = uriArray[uriArray.length - 1];
//   const newUrl = `${WORDPRESS_ASSETS_ROOT}/${lastElement}`;
//   return newUrl;
// };

export const hashString = (string) => {
  let arr = string.split('');
  return arr.reduce(
    (hashCode, currentVal) => (hashCode = currentVal.charCodeAt(0) + (hashCode << 6) + (hashCode << 16) - hashCode),
    0,
  );
};
/**
 * funkcja liczy wysokość bez paddingów
 */
export function getContentHeight(element) {
  let heightWithPaddings = element.clientHeight;

  const elementComputedStyle = window.getComputedStyle(element);
  return (
    heightWithPaddings - parseFloat(elementComputedStyle.paddingTop) - parseFloat(elementComputedStyle.paddingBottom)
  );
}

export const checkHeight = (element, heightToCheck) => {
  if (element) {
    const contentHeight = getContentHeight(element);

    return contentHeight > heightToCheck;
  } else {
    return false;
  }
};

export function calculateListHeight(listSelector, itemLimit = Infinity) {
  const listElement = typeof listSelector === 'string' ? document.querySelector(listSelector) : listSelector;

  if (!listElement) {
    return null;
  }

  const listStyles = window.getComputedStyle(listElement);
  const childItems = listElement.querySelectorAll('li');

  const totalItemCount = childItems.length;

  const N_toMeasure = Math.min(totalItemCount, itemLimit);

  if (N_toMeasure === 0) {
    return { totalItemCount: 0, calculatedHeight: 0 };
  }

  const padTop = parseFloat(listStyles.getPropertyValue('padding-top'));
  const padBottom = parseFloat(listStyles.getPropertyValue('padding-bottom'));
  const totalPadding = padTop + padBottom;

  const gapPx = parseFloat(listStyles.getPropertyValue('row-gap')) || 0;
  const totalGapHeight = (N_toMeasure > 0 ? N_toMeasure - 1 : 0) * gapPx;

  let totalLiHeight = 0;
  for (let i = 0; i < N_toMeasure; i++) {
    totalLiHeight += childItems[i].offsetHeight;
  }

  const calculatedHeight = totalPadding + totalLiHeight + totalGapHeight;

  return { itemsCount: totalItemCount, calculatedHeight: calculatedHeight };
}

export function applyCalculatedHeight(parentSelector, listSelector) {
  const { calculatedHeight, itemsCount } = calculateListHeight(listSelector, 6);
  if (calculatedHeight === null) {
    return;
  }

  const parentElement = document.querySelector(parentSelector);
  if (!parentElement) {
    return;
  }

  const heightString = `${calculatedHeight}px`;
  parentElement.style.height = heightString;

  return itemsCount;
}

export const formatCanonical = (url) => {
  if (!url) {
    return;
  }

  const parsedUrl = new URL(url);

  let newPathname = parsedUrl.pathname.replace('/wp', '/artykuly').replace('/category/', '/');

  const originalParams = parsedUrl.searchParams;
  const newParams = new URLSearchParams();
  if (originalParams.has('page')) {
    newParams.set('page', originalParams.get('page'));
  }

  let finalUrl = `${parsedUrl.origin}${newPathname}`;

  const newQueryString = newParams.toString();
  if (newQueryString) {
    finalUrl += `?${newQueryString}`;
  }

  return removeLastTrailingSlash(finalUrl);
};

export const formatCategoryUrl = (rawUri) => {
  if (!rawUri) return '/artykuly/';

  let cleanUri = rawUri.replace('/blog/wp', '');

  cleanUri = cleanUri.replace('/category/', '/');

  const slug = cleanUri.split('/').filter(Boolean).join('/');

  return `/artykuly/${slug}/`;
};

export const flatListToHierarchical = (
  data = [],
  { idKey = 'id', parentKey = 'parentId', childrenKey = 'children' } = {},
) => {
  const tree = [];
  const childrenOf = {};

  data.forEach((item) => {
    const newItem = { ...item };
    const { [idKey]: id, [parentKey]: parentId = null } = newItem;

    childrenOf[id] = childrenOf[id] || [];
    newItem[childrenKey] = childrenOf[id];

    if (parentId) {
      childrenOf[parentId] = childrenOf[parentId] || [];
      childrenOf[parentId].push(newItem);
    } else {
      tree.push(newItem);
    }
  });

  return tree;
};

export const getMenuDepth = (item) => {
  if (!item.children || item.children.length === 0) {
    return 1;
  }
  return 1 + Math.max(...item.children.map(getMenuDepth));
};

// removes whitespaces and double slashes except https://
export const sanitizeUrl = (url) => {
  if (!url) return '';
  return url.trim().replace(/(?<!:)\/{2,}/g, '/');
};

export const getYouTubeId = (url) => {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^&]{11})/);
  return match ? match[1] : null;
};

export const sanitizeGraphQLPayload = (rawText) => {
  return rawText
    .replaceAll('https://pl.canalplus.com/blog/wp/wp-content/uploads/', '/blog/cms-assets/')
    .replaceAll('http://wordpress:80/blog/wp/wp-content/uploads/', '/blog/cms-assets/');
};
